import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { PennywiseAddressCardStackBackgroundViewModel } from './pennywise-address-card-stack-background-view-model';
import { CardBackgroundComponent } from '../../card-background.component';
import { CardData } from '../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-pennywise-address-card-stack-background',
  templateUrl: './pennywise-address-card-stack-background.component.html',
  styleUrls: ['./pennywise-address-card-stack-background.component.scss'],
  providers: [PennywiseAddressCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PennywiseAddressCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public viewModel: PennywiseAddressCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: CardData;
}
